module.exports = __webpack_public_path__ + "static/media/failure-analysis.41b2a691.PNG";